import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/shared/services/users.service';

@Component({
  selector: 'app-desma',
  templateUrl: './desma.component.html',
  styleUrls: ['./desma.component.css']
})
export class DesmaComponent implements OnInit {
  data = {
    module : "Design and Manufacturing"
  }

  constructor(
    private usersService : UsersService,
    private router: Router
  ) { 
    
  }

  ngOnInit(): void {
  }

  async completed() {
    
    let courseCompleted = {
      module1: this.data.module
    }
    await this.usersService.userProgress(courseCompleted);
   
    this.router.navigate(['/battery-technology']);
  }


}
